/** @module                     Hooks */

import useFetch                 from "../../../../../Hooks/useFetch";

import { useEffect }            from "react";

import { useTranslation }       from "react-i18next";

/** @module Queries */

import { POSTS_LANGUAGE_ENUM }  from "../../../../../Queries/Posts";

/** @module                     Utilities */

import { enumOptions }          from "../../../Utils/enumOptions";

/** @module                     Components */

import Attributes               from "../../../Global/Forms/Fieldset/Attributes";

import Fieldset                 from "../../../Global/Forms/Fieldset";

import Select                   from "../../../Global/Forms/Select";

import CenterLoader             from "../../../Loaders/CenterLoader";

import MutationActions          from "../../../Global/Layouts/Mutations/MutationActions";

import Checkbox                 from "../../../Global/Forms/Checkbox";

const 

/**
 * 
 * @param { Object } data 
 * 
 * @param { Object } details
 * 
 * @returns edit post sidebar component
 * 
 */

Sidebar = ( { data, details } ) => { const { t } = useTranslation (),

    { data : enumData, loading } = useFetch ( POSTS_LANGUAGE_ENUM ),

    /** @event onClick */

    updateIsPublished       = e => details.isPublished.set      ( e.target.checked ),

    updateTiremarketOnly    = e => details.tiremarketOnly.set   ( e.target.checked );

    /** @returns */

    return ( <aside>

        <Fieldset legend={ t ( "actions" ) }>

            <Attributes details={ [

                { name: t ( "createdAt" ), value: new Date ( data.createdAt ).toLocaleString () },

                { name: t ( "updatedAt" ), value: new Date ( data.updatedAt ).toLocaleString () },

                { name: t ( "language" ), value: data.language },

            ] } />

            <MutationActions 

                remove={ true }
                
                submitAction={ details.submit.action }

                removeAction={ details.remove.action }
                
                references={ [ details.submit.reference, details.remove.reference ] } />

        </Fieldset>

        <Fieldset legend={ t ( "image" ) }>

            <div className="entry-image">

                <img src={ details.image.view } />

            </div>

            <input 
            
                type="file" 
            
                defaultValue="" 
            
                onChange={ e => details.image.set ( e.target.files[ 0 ] ) } />

        </Fieldset>

        <Fieldset legend={ t ( "options" ) }>

            { loading ? <CenterLoader /> : 

                <Select 
                    
                    id="language"
                    
                    action={ e => details.language.set ( e ) }
                    
                    options={ enumOptions ( enumData.__type.enumValues ) }
                    
                    value={ details.language.view }
                    
                    ref={ details.language.reference } />

            }

            <Checkbox 
                
                id="isPublished" 
            
                text={ t ( "isPublished" ) } 
            
                value={ data.isPublished } 
            
                state={ data.isPublished } 
            
                action={ updateIsPublished } />

            <Checkbox 
            
                id="tiremarketOnly" 
            
                text={ t ( "tiremarketOnly" ) } 
            
                value={ data.tiremarketOnly } 
            
                state={ data.tiremarketOnly } 
            
                action={ updateTiremarketOnly } />

        </Fieldset>

    </aside> );

}

/** @exports Sidebar */
 
export default Sidebar;